import { useUserStore } from '~/stores/user';
import { useApiUser, type UserSettings } from './api-services/api-user';

export const useUserSettings = () => {
  const userStore = useUserStore();

  const apiUser = useApiUser();

  const isSaveUserSettingsLoading = ref(false);

  const saveUserSettings = async (
    settings: UserSettings,
    callback?: () => void
  ) => {
    if (isSaveUserSettingsLoading.value) {
      return;
    }

    isSaveUserSettingsLoading.value = true;
    try {
      await apiUser.changeUserSettings({ settings });

      await userStore.getUser();

      if (callback) {
        callback();
      }
    } catch (error) {
      useErrorHandler(error);
    } finally {
      isSaveUserSettingsLoading.value = false;
    }
  };
  return {
    isSaveUserSettingsLoading,
    saveUserSettings,
  };
};
